module.exports = __webpack_public_path__ + "static/slider-1-1-movil-a8a30a2a1d436c8d6be98d833cb5cf74.jpg";